import { render } from "./SVGRedo.vue?vue&type=template&id=ed9daf40"
import script from "./SVGRedo.vue?vue&type=script&lang=js"
export * from "./SVGRedo.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__